<template>
  <div>
    <!-- 第一步选择单位 -->
    <AgencyList v-if="step === 1"/>
    <StepTwo ref="stepTwo" v-if="step === 2" @signupSuccess="signData"></StepTwo>
    <StepThree ref="stepThree" v-if="step === 3" @payOver="payOver"></StepThree>
    <PaySuccess ref="paySuccess" v-if="step === 4"></PaySuccess>
    <div class="btnContent">
      <div class="btn top20" @click="lastStep()" v-if="step > 1">{{ (step === 3 || step === 4) ? '继续报名' : '上一步' }}</div>
      <div class="btn top20" @click="submit()" v-if="step === 2">提交报名</div>
      <div class="btn top20" @click="nextStep()" v-if="step === 1">下一步</div>
      <div class="btn top20" @click="signData()" v-if="step > 1 && step < 3">查看报名数据</div>
      <div class="btn top20" @click="downloadData()" v-if="step === 3">下载凭证</div>
    </div>
  </div>
</template>
<script>
// import store from '@/store'
import AgencyList from '../agency/AgencyList'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import PaySuccess from '@comm/components/join/pay/PaySuccess'
import { mapState } from 'vuex'
export default {
  components: {
    AgencyList,
    StepTwo,
    StepThree,
    PaySuccess
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      agencyId: this.$route.query.agencyId || null,
      step: Number(this.$route.query.step || 1)
    }
  },
  computed: {
    ...mapState({
      joinAgency: state => state.join.joinAgency
    })
  },
  methods: {
    lastStep () {
      switch (this.step) {
      case 2:
        this.step = 1
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 1}})
        break
      case 3:
      case 4:
        this.step = 2
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.joinAgency.agencyId}})
        break
      }
    },
    nextStep () {
      switch (this.step) {
      case 1:
        if (this.joinAgency.agencyId === null) {
          this.$message.error('请选择单位')
          return
        }
        this.step = 2
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 2, agencyId: this.joinAgency.agencyId}})
        break
      }
    },
    signData () {
      this.step = 3
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 3, agencyId: this.joinAgency.agencyId}})
    },
    downloadData () {
      this.$refs.stepThree.paySuccess(true)
    },
    payOver () {
      this.step = 4
      this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: 4, agencyId: this.joinAgency.agencyId}})
    },
    submit () {
      this.$refs.stepTwo.signUp()
    }
  }
}
</script>
<style lang="scss" scoped>
  .btnContent {
    text-align: center;
    .btn{
      color: #fff;
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      right: 250px;
      bottom: 29px;
      text-align: center;
      border-radius: 2px;
      background-color: #b80000;
      cursor:pointer;
      display: inline-block;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .top20 {
      margin-top: 20px;
    }
    .left20 {
      margin-left: 20px;
    }
    .right20 {
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/BigBallJoin.vue